import * as textMaskAddons from "text-mask-addons";

export const DATE_PIPE = textMaskAddons.createAutoCorrectedDatePipe
  ? textMaskAddons.createAutoCorrectedDatePipe("yyyy-MM-dd")
  : null;

export const MASK = [
  /[1-2]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  "-",
  /[0-1]/,
  /[0-9]/,
  "-",
  /[0-3]/,
  /[0-9]/,
];
